// extracted by mini-css-extract-plugin
export default {"PaginationStatus":"VQF0u2qRs2qtpyVLGNYs","StatusButton":"YBPRkb9AIKTsMfnifn6d","DownArrow":"cVzq0GUVWaVur9PebxdU"};